import { render, staticRenderFns } from "./LeakageCauseWorkerWorksBeforeQuestion.vue?vue&type=template&id=2ddfe3d8&scoped=true"
import script from "./LeakageCauseWorkerWorksBeforeQuestion.vue?vue&type=script&lang=ts"
export * from "./LeakageCauseWorkerWorksBeforeQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddfe3d8",
  null
  
)

export default component.exports